declare global {
  interface Window {
    YT: any;
    onYouTubeIframeAPIReady: () => void;
  }
}

class Video {
  constructor() {
    this._init();
  }

  _init() {

    const youtubeIframes: NodeListOf<HTMLIFrameElement> = document.querySelectorAll('.video-container iframe[src*="youtube.com/embed"], .video-container iframe[src*="youtube-nocookie.com/embed"]');

    if (youtubeIframes.length > 0) {
      this._loadYouTubeAPI();
    }
    this._setupVideoPlayers();

  }


  _loadYouTubeAPI(): void {
    if (!window.YT) {
      const tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      const firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag?.parentNode?.insertBefore(tag, firstScriptTag);

      // Définir le callback pour quand l'API est prête
      window.onYouTubeIframeAPIReady = this._setupYouTubePlayers.bind(this);
    } else {
      this._setupYouTubePlayers();
    }
  }

  _setupVideoPlayers(): void {
    const videos: NodeListOf<HTMLVideoElement> = document.querySelectorAll('.video-container video');

    videos.forEach((video) => {
      const playButton: HTMLButtonElement | null | undefined = video.parentElement?.querySelector('.video-container__button');

      if (playButton) {
        playButton.addEventListener('click', () => {
          if (video.paused) {
            video.play();
            playButton.style.display = 'none';
          } else {
            video.pause()
            playButton.style.display = 'block';
          }
        });

        video.addEventListener('click', () => {
          if (video.paused) {
            playButton.style.display = 'none';
          } else {
            playButton.style.display = 'block';
          }

        });
        video.addEventListener('play', () => {
          playButton.style.display = 'none';
        });

        video.addEventListener('pause', () => {
          playButton.style.display = 'block';
        });
        video.addEventListener('ended', () => {
          playButton.style.display = 'block';
        });
      }
    });
  }

  _setupYouTubePlayers(): void {
    const youtubeIframes: NodeListOf<HTMLIFrameElement> = document.querySelectorAll('.video-container iframe[src*="youtube.com/embed"], .video-container iframe[src*="youtube-nocookie.com/embed"]');

    youtubeIframes.forEach((iframe) => {
      const playButton: HTMLButtonElement | null | undefined = iframe.parentElement?.querySelector('.video-container__button');

      if (!playButton) return;

      const videoId = this._getYouTubeVideoId(iframe.src);
      if (!videoId) return;

      // Initialiser le lecteur YouTube
      const player = new window.YT.Player(iframe, {
        videoId,
        events: {
          onStateChange: (event: any) => this._handlePlayerStateChange(event, playButton),
          // onReady: (event: any) => this._handlePlayerReady(event, playButton, player),
        },
      });

      playButton.addEventListener('click', () => {
        // La méthode getPlayerState() est maintenant utilisée après l'événement onReady
        const playerState = player.getPlayerState();
        if (playerState === window.YT.PlayerState.PAUSED || playerState === window.YT.PlayerState.ENDED || playerState === 5) {
          player.playVideo();
          playButton.style.display = 'none';
        }
      });
    });
  }


  _handlePlayerReady(event: any, playButton: HTMLButtonElement, player: any): void {
    // Assurer que le lecteur est prêt avant d'utiliser getPlayerState
    const playerState = player.getPlayerState();
    if (playerState === window.YT.PlayerState.PAUSED || playerState === window.YT.PlayerState.ENDED) {
      playButton.style.display = 'block';
    }
  }

  _handlePlayerStateChange(event: any, playButton: HTMLButtonElement): void {
    const playerState = event.data;

    if (playerState === window.YT.PlayerState.PLAYING) {
      playButton.style.display = 'none';
    } else if (playerState === window.YT.PlayerState.PAUSED || playerState === window.YT.PlayerState.ENDED) {
      playButton.style.display = 'block';
    }
  }

  _getYouTubeVideoId(url: string): string | null {
    const regex = /(?:youtube\.com\/(?:[^/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/|youtube-nocookie\.com\/embed\/)([^"&?/\s]{11})/;
    const match = url.match(regex);
    return match ? match[1] : null;
  }

}

export const video = new Video();
